import React from 'react';
import cn from 'classnames';
import styles from './TableContainer.module.scss';

const TableContainer = ({ removePadding = false, tableClassName, ...props }) => {
  return (
    <div
      className={cn(styles.tableContainer, {
        [styles.sidePadding]: !removePadding,
      })}
    >
      <table {...props} className={tableClassName} />
    </div>
  );
};

export default TableContainer;
